const environment = {
    // endPoint: "https://dealler-backend.onrender.com/api/v1/admin",
    //  socketEndPoint:"https://dealler-backend.onrender.com",

    //  socketEndPoint:"http://65.2.45.228:8000",
    // endPoint: "http://65.2.45.228:8000/api/v1/admin",

    // socketEndPoint:"http://localhost:8000",
    // endPoint: "http://localhost:8000/api/v1/admin",


    socketEndPoint:"https://kundanlalagroapi.njssolutions.in",
     endPoint: "https://kundanlalagroapi.njssolutions.in/api/v1/admin",
   
  };

  export default environment;


